import { Formatter } from '@/filters/formatter'
import { StatisticsAnalysisGeneralStatisticsTrackingItems } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Nullable } from '@/shared/types/app.types'
import { AxisLabelsFormatterContextObject, Options, Point, PointLabelObject, TooltipFormatterContextObject } from 'highcharts'

export interface StatisticalAnalysisGeneralStatisticsGeneralState {
    itemSelected: Nullable<StatisticsAnalysisGeneralStatisticsTrackingItems>
    chartOptions: Options
    trackingItems: StatisticsAnalysisGeneralStatisticsTrackingItems[]
    promiseGeneralViewTracking: Nullable<Promise<void>>
}

const chartOptions: Options = {
    chart: {
        type: 'column',
        height: 300
    },
    accessibility: {
        announceNewData: {
            enabled: true
        }
    },
    xAxis: {
        type: 'category',
        labels: {
            formatter: function() {
                const context: AxisLabelsFormatterContextObject<any> = this
                return context.value
            }
        }
    },
    yAxis: {
        max: 100
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            dataLabels: {
                enabled: true,
                formatter: function() {
                    const context: PointLabelObject = this
                    if (!context.y || context.y <= 0) {
                        return ''
                    }
                    return `${Formatter.number(context.y, true)}%`
                }
            }
        }
    },
    tooltip: {
        useHTML: true,
        formatter: function() {
            const context: TooltipFormatterContextObject = this
            const point: Point = context.point
            return `
                <span>${context.series.name}</span><br>
                <span style="color:${context.color}">${point.name}</span>: <b> ${Formatter.number(context.y, true)}%</b><br/>`
        }
    }
}
export const initialStatisticalAnalysisGeneralStatisticsGeneral =
    (): StatisticalAnalysisGeneralStatisticsGeneralState => ({
        itemSelected: null,
        chartOptions,
        trackingItems: [],
        promiseGeneralViewTracking: null
    })
